import { render, staticRenderFns } from "./education_history.vue?vue&type=template&id=3e84c0f6&"
import script from "./education_history.vue?vue&type=script&lang=js&"
export * from "./education_history.vue?vue&type=script&lang=js&"
import style0 from "./education_history.vue?vue&type=style&index=0&id=3e84c0f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports